import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { saveAs } from 'file-saver';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GenerateIncrementlettersPreviewPopupComponent } from 'src/app/shared/popups/generate-incrementletters-preview-popup/generate-incrementletters-preview-popup.component';

@Component({
  selector: 'app-generate-variable-pay-letters',
  templateUrl: './generate-variable-pay-letters.component.html',
  styleUrls: ['./generate-variable-pay-letters.component.scss'],
})
export class GenerateVariablePayLettersComponent implements OnInit {

  buttonColorName: any;
  isShowDownloadBtn: boolean = false;
  selectAllChecked: boolean = false;

  variablePayLetter: any[] = [];
  vpInputPayload: any;
  searchString:any=null;
  constructor(public router: Router,private httpService: HttpService,private config:Config,
    private loader: LoaderService,public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
  }
  ionViewWillEnter() {
    this.vpInputPayload = JSON.parse(sessionStorage.getItem('vpInputPayload') || '{}');
    this.searchString = this.vpInputPayload.searchString
    this.getInputLettersOfVP();
  }
  toggleSelectAll() {
    this.variablePayLetter.forEach(item => item.isChecked = this.selectAllChecked);
    this.isShowDownloadBtn = this.selectAllChecked;
  }

  onCheckboxChange() {
    const allChecked = this.variablePayLetter.every(item => item.isChecked);
    const anyChecked = this.variablePayLetter.some(item => item.isChecked);

    this.selectAllChecked = allChecked;
    this.isShowDownloadBtn = anyChecked;
  }

  onClickVariablePaySetup(operation: any) {
    this.router.navigate(['/home/hrportal/variablepay']);
  }
  getInputLettersOfVP() {
    const request = {
      "band": this.vpInputPayload.band,
      "companyId": this.vpInputPayload.companyId,
      "department": this.vpInputPayload.department,
      "employeeId": this.vpInputPayload.employeeName,
      "frequencyCycle": this.vpInputPayload.frequencyCycle,
      "fromYear": this.vpInputPayload.fromYear,
      "managerId": this.vpInputPayload.managerName,
      "rating": this.vpInputPayload.rating,
      "searchString": this.searchString,
      "toYear": this.vpInputPayload.toYear,
    } 
    this.httpService.callPostService(this.config.getInputLettersOfVP, request).subscribe((result: any) => {
      this.variablePayLetter = [];
      result.data?.forEach((ele:any)=>{
        let obj={
          employeeName: ele.employeeName,
          isChecked: false,
          normalisation_HR_MD_CEO: ele.normalisation_HR_MD_CEO,
          userId: ele.userId
        }
        this.variablePayLetter.push(obj)
      })
    });
  }
  debounceTimer: any;
  onSearchInput(event: any) {
    this.searchString = event.target.value;
    if (this.searchString == '') {
      this.searchString = null;
    }
    // Clear the previous timer if the user is still typing
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new timer, e.g., 300ms after the user stops typing
    this.debounceTimer = setTimeout(() => {
      this.getInputLettersOfVP();
    }, 300);
  }
  downloadVpLetter(){
    const request = {
      "companyId": this.vpInputPayload.companyId,
      "frequencyCycle": this.vpInputPayload.frequencyCycle,
      "fromYear": this.vpInputPayload.fromYear,
      "toYear": this.vpInputPayload.toYear,
      "userId": this.variablePayLetter?.filter(employee => employee.isChecked)?.map(employee => employee.userId)
    };
    this.loader.simpleLoader();
    this.httpService.callPostService(this.config.VPgetLetterOfUsers, request).subscribe((result: any) => {
      if(result?.data!=null){
        saveAs(result?.data, 'VariablePayLetter'); 
      }
      this.loader.dismissLoader();
    });
  }
  onClickPreviewLetter(userName: any, userId: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '100%';
    dialogConfig.width = '100%'; 
    dialogConfig.data = {
      userName: userName,
      userId: userId,
      incrementLetterData: [],
      moduleName: 'VP',
      vpInputPayload: this.vpInputPayload
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(GenerateIncrementlettersPreviewPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {});    
  }
}
